import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query AbsenceReasonsPagination($page: Int, $pageSize: Int) {
  absenceReasonsPagination(page: $page, pageSize: $pageSize) {
    absenceReasons {
      id
      message
      teams {
        id
        name
      }
      allTeamsOn
    }
    pageSize
    totalCount
  }
}`;

function getAbsenceReasonsPagination(page, pageSize) {
  return apollo.client.query({
    query,
    variables: {
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((data) => data.data.absenceReasonsPagination);
}

export default getAbsenceReasonsPagination;
